export default __webpack_public_path__ + "static/media/single-project-page-01-img02.7181cce8.jpg";